var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"flex-sp"},[_c('div',{staticClass:"add-title"},[_vm._v(" "+_vm._s(_vm.videoTitle)+" ")]),_c('div',[_c('butn',{attrs:{"btntype":"primary","iconName":"el-icon-arrow-left","title":"返回"},on:{"click":function($event){return _vm.$router.back()}}})],1)]),_c('div',{attrs:{"id":"dplayer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }